module.exports = __webpack_public_path__ + "img/parks-1-1.a5d5bc63.jpg";